// extracted by mini-css-extract-plugin
export default {"link":"style_link__N0H0R","centerGrid":"style_centerGrid__ojHdn","img":"style_img__ySfAA","namegame":"style_namegame__n7BfP","center":"style_center__dxzAQ"};